module.exports = __webpack_public_path__ + "img/WORD.406aafe4.png";